/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDateOverviewQueryResponse, GetStatsByDateOverviewQueryParams, GetStatsByDateOverview400 } from '../entities/GetStatsByDateOverview'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getStatsByDateOverview } from '../api/getStatsByDateOverview'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getStatsByDateOverviewQueryKey = (params?: GetStatsByDateOverviewQueryParams) =>
  [{ url: '/stats/by-date/overview' }, ...(params ? [params] : [])] as const

export type GetStatsByDateOverviewQueryKey = ReturnType<typeof getStatsByDateOverviewQueryKey>

export function getStatsByDateOverviewQueryOptions(
  params?: GetStatsByDateOverviewQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const queryKey = getStatsByDateOverviewQueryKey(params)
  return queryOptions<
    GetStatsByDateOverviewQueryResponse,
    ResponseErrorConfig<GetStatsByDateOverview400>,
    GetStatsByDateOverviewQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getStatsByDateOverview(params, config)
    },
  })
}

/**
 * @description Get stats by date overview
 * @summary Get stats by date overview
 * {@link /stats/by-date/overview}
 */
export function useGetStatsByDateOverview<
  TData = GetStatsByDateOverviewQueryResponse,
  TQueryData = GetStatsByDateOverviewQueryResponse,
  TQueryKey extends QueryKey = GetStatsByDateOverviewQueryKey,
>(
  params?: GetStatsByDateOverviewQueryParams,
  options: {
    query?: Partial<QueryObserverOptions<GetStatsByDateOverviewQueryResponse, ResponseErrorConfig<GetStatsByDateOverview400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getStatsByDateOverviewQueryKey(params)

  const query = useQuery(
    {
      ...(getStatsByDateOverviewQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetStatsByDateOverview400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}